import React from 'react';
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';
import { withRouter } from 'react-router'
//import { send_email } from 'email_function'

var devices = ''
var device = ''

export default class UserMenu extends React.Component {

  constructor(props) {
    super(props);
    this.send_email = this.send_email.bind(this)
    this.get_device = this.get_device.bind(this)
  }

  get_device() {
       var select_item = document.getElementById("device")
       console.log(select_item.selectedIndex)
       devices = this.data.sn
       device = devices[select_item.selectedIndex]
       console.log('device: ' + device)
  }

  componentDidMount() {
       console.log('get_device')
       var select_item = document.getElementById("device")
       console.log(select_item.selectedIndex)
       var option = document.createElement("option")
       var xhr1 = new XMLHttpRequest()
       xhr1.addEventListener('load', () => {
       this.data = JSON.parse(xhr1.responseText);//parse response text into data object

       if (this.data.result === "OK") {
          console.log(this.data.result)
          console.log(this.data.location_desc[1])
          console.log(this.data.sn)
          devices = this.data.sn
          device = devices[0]
          console.log('device: ' + device)
          for(var i=0;i<this.data.sn.length;i++){
             option = document.createElement("option")
              option.text = this.data.location_desc[i]
              option.value = this.data.location_desc[i]
              select_item.add(option)
          }
        }else{
              option = document.createElement("option")
              option.text = "No Devices Available"
              select_item.add(option)
        }

                })
        xhr1.open('POST', 'http://3.21.222.196:3035/get_devices');//87 is considered unsafe by Chrome
        xhr1.setRequestHeader("Content-Type", "application/json");
        xhr1.send(JSON.stringify({'email': this.readCookie('email')}));
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

  send_email() {
  var device_ip_address = ''
    console.log('send_email clicked')
    console.log('email_cookie: ', this.readCookie('email'))
    console.log(device[0]);


	//    var email_to = 'marc.t.mclean@gmail.com'

       	    // get device_local_ip_address
    var xhr2 = new XMLHttpRequest()
	xhr2.addEventListener('load', () => {
       var data = JSON.parse(xhr2.responseText);//parse response text into data object
       console.log(data)
       device_ip_address = data.ip_address
       console.log('device_ip_address: ' + device_ip_address)
       var email_to = this.readCookie('email')
      var xhr1 = new XMLHttpRequest()
	  xhr1.addEventListener('load', () => {
       var data = JSON.parse(xhr1.responseText);//parse response text into data object
       console.log(data)
       alert('An email has been sent to the account owner')
       this.props.history.push({
               pathname: '/user_menu'
              })

      	})
      console.log('device_ip_address: ' + device_ip_address)
      xhr1.open('POST', 'http://3.21.222.196:5115/send_email');
      xhr1.send(JSON.stringify({'to_email': this.readCookie('email'), 'device_ip_address': device_ip_address, 'serial_number': device}));

       	})

	      xhr2.open('POST', 'http://3.21.222.196:5005/get_ip_address_for_camera_setup');
      xhr2.send(JSON.stringify({'serial_number': device}));

  }

  render() {

    return (
      <div className='container'>
        <div className="container6">
        <div className="header">
          <div className="menu1">
            <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
          </div>
          <div className="menu2"><a href="/#setup">Setup</a></div>
          <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
          <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
          <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
        </div>
        <div className="row">
          <center>
            <div className="camera_setup">

              <div className="camera_setup">
                <img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
                <br></br><br></br><br></br><br></br><br></br>
                <center>
                  <p className="camera_setup_title2">Galayou G7 IP Camera Set Up - Preferred Method</p>
              <br></br>
                <div className='camera_setup_div'>
                <span className='camera_setup_span'>1. On the "Modify Device Settings" screen, select "Security Camera" as the Camera Type. This is the default.
                </span><br></br>
                <span className='camera_setup_span'>2. Download the Wansview app to your iPhone or Android device
                </span>
                <br></br>
                <span className='camera_setup_span'>3. Follow the directions to connect to the G7 security camera.
                </span>
                <br></br>
                <span className='camera_setup_span'>4. From within the Wansview app. 0
                lick the settings icon. Then click "Local application". Then click "RTSP". Record the IP address
                </span>
                <br></br>
                <span className='camera_setup_span'>5. Go to the "Modify Device Settings" screen and enter the IP address of your security camera in the "Security camera RSTP address" field.
                </span>
                <br></br>
                <span className='camera_setup_span'>6. The Apollo music player will automatically connect to the IP camera.
                </span>
                </div><br></br>

                <p className="camera_setup_title">WebCam Set Up</p>
                             <div className='camera_setup_span'>
                                  <label className="camera_setup_span">Select location:</label><br></br>
                                  <select id="device" name="device" size="1" onChange={this.get_device}>
                                  </select>
              </div>
              <br></br>
                <div className='camera_setup_div'>
                <span className='camera_setup_span'>Select the device above. Then click the Send Email button below to send an email to the
                account owner. The email will contain a link to access the Apollo Music Player webcam streaming video.
                <br></br>The link will be active for 5 minutes.
                </span>
                </div><br></br>
                <br></br>
                <button onClick={this.send_email}>Send Email</button>
                </center>
                
              </div>

            </div>
          </center>
          
        </div>
        <br></br><br></br><br></br><br></br><br></br><br></br>
        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
        <br></br>
        </div>
        </div>
      </div >
    );
  }
}